/* Bilingual content for Login page */

export const LOGIN_CONTENT = {
  en: {
    signIn: "Sign in",
    subtitle: "Enter your email and password.",
    email: "Email",
    password: "Password",
    signingIn: "Signing in…",
    loginFailed: "Login failed",
    newCustomer: "New customer? Your account is created automatically after your first purchase.",
    startEligibility: "Start your eligibility check",
  },
  es: {
    signIn: "Iniciar Sesión",
    subtitle: "Ingresa tu correo electrónico y contraseña.",
    email: "Correo Electrónico",
    password: "Contraseña",
    signingIn: "Iniciando sesión…",
    loginFailed: "Error al iniciar sesión",
    newCustomer: "¿Cliente nuevo? Tu cuenta se crea automáticamente después de tu primera compra.",
    startEligibility: "Comienza tu verificación de elegibilidad",
  },
};

export function getLoginContent(lang) {
  return LOGIN_CONTENT[lang] || LOGIN_CONTENT.en;
}
